<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar afiliado" : "Nuevo afiliado" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>
              {{ editing ? "Datos del afiliado" : "Datos del nuevo afiliado" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div>
                <h2 class="form-subtitle">Información general</h2>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="identifier_type">Tipo de documento * </label>
                    <FormSelect id="identifier_type" v-model="form.identifier_type" :items="identifierTypes"
                      defaultOption="Elegir tipo de documento" :showError="$v.form.identifier_type.$error &&
                        !$v.form.identifier_type.required
                        " />
                    <FormError v-if="
                      $v.form.identifier_type.$error &&
                      !$v.form.identifier_type.required
                    " message="Tipo de documento es requerido" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="identifier_number">Número de documento *</label>
                    <input id="identifier_number" type="text" :maxlength="maxLengthIdentifier" v-model.trim="form.identifier_number"
                      autocomplete="off" placeholder="Ingresar número de documento" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.identifier_number.$error,
                      }" />
                    <FormError v-if="
                      $v.form.identifier_number.$error && !$v.form.identifier_number.required
                    " message="Número de documento es requerido" />
                    <!-- <FormError
                    v-if="
                      $v.form.identifier_number.$error &&
                      !$v.form.identifier_number.numeric
                    "
                    message="Número de documento debe tener un valor numérico"
                  /> -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="name">Nombre o Razón Social *</label>
                    <input id="name" type="text" v-model="form.name" autocomplete="off"
                      placeholder="Ingresar Nombre o Razón Social" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.name.$error,
                      }" />
                    <FormError v-if="$v.form.name.$error && !$v.form.name.required"
                      message="Nombre o Razón Social es requerido" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="contact_person">Persona de contacto</label>
                    <input id="contact_person" type="text" v-model="form.contact_person" autocomplete="off"
                      placeholder="Ingresar Persona de contacto" class="custom-form-control" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="email">Correo electrónico *</label>
                    <FormInput id="email" novalidate type="email" maxlength="100"
                      placeholder="Ingresa tu correo electrónico" :show-error="($v.form.email.$error && !$v.form.email.required) ||
                        ($v.form.email.$error && !$v.form.email.email)
                        " v-model="form.email" />

                    <form-error message="Correo electrónico es requerido"
                      v-if="$v.form.email.$error && !$v.form.email.required"></form-error>

                    <form-error message="El correo electrónico ingresado no es válido"
                      v-if="$v.form.email.$error && !$v.form.email.email"></form-error>

                    <!-- <form-error :message="error" v-if="error"></form-error> -->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="address">Dirección</label>
                    <input id="address" type="text" v-model="form.address" autocomplete="off"
                      placeholder="Ingresar Dirección" class="custom-form-control" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="phone_number">Número de celular *</label>
                    <input id="phone_number" type="text" v-model.trim="form.phone_number" autocomplete="off"
                      placeholder="Ingresar número de teléfono" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.phone_number.$error,
                      }" />
                    <FormError v-if="$v.form.phone_number.$error && !$v.form.phone_number.numeric"
                      message="Número de teléfono debe ser un valor numérico" />
                    <FormError message="Ingresa el código de país"
                      v-if="$v.form.phone_number.$error && !$v.form.phone_number.startsWithPlus"></FormError>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="commission">Comisión por viaje *</label>
                    <input id="commission" type="number" v-model="form.commission" autocomplete="off"
                      placeholder="Ingresar Comisión por viaje" class="custom-form-control" :class="{
                        'custom-form-control-error': $v.form.commission.$error,
                      }" />
                    <FormError v-if="
                      $v.form.commission.$error && !$v.form.commission.required
                    " message="Comisión por viaje es requerida" />
                    <FormError v-if="
                      $v.form.commission.$error && !$v.form.commission.numeric
                    " message="Comisión por viaje debe ser un número" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group" :class="{ 'mb-0': !isHotel }">
                    <label for="commission_type">Tipo de comisión * </label>
                    <FormSelect id="commission_type" v-model="form.commission_type" :items="commissionOptions"
                      defaultOption="Elegir tipo de comisión" :showError="$v.form.commission_type.$error &&
                        !$v.form.commission_type.required
                        " />
                    <FormError v-if="
                      $v.form.commission_type.$error &&
                      !$v.form.commission_type.required
                    " message="Tipo de comisión es requerido" />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="category_id">Categoría *</label>
                    <FormSelect id="category_id" v-model="form.category_id" :items="categories"
                      defaultOption="Elegir categoría" :showError="$v.form.category_id.$error &&
                        !$v.form.category_id.required
                        " />
                    <FormError v-if="
                      $v.form.category_id.$error && !$v.form.category_id.required
                    " message="Categoría es requerida" />
                  </div>
                </div>

                <div class="col-md-6" v-if="isHotel">
                  <div class="form-group mb-0">
                    <label for="categoryType">Tipo de hotel * </label>
                    <FormSelect id="hotel_type" v-model="form.hotel_type" :items="hotelTypesOptions"
                      defaultOption="Elegir tipo de hotel" :showError="$v.form.hotel_type.$error &&
                        !$v.form.hotel_type.required
                        " />
                    <FormError v-if="
                      $v.form.hotel_type.$error &&
                      !$v.form.hotel_type.required
                    " message="Tipo de hotel es requerido" />
                  </div>
                </div>
              </div>

              <!-- Listas de precios vinculadas (DEF-ADM-010) -->
              <div v-if="editing" class="mt-4">
                <h2 class="form-subtitle">Listas de Precios</h2>
                <p class="text-muted" style="font-size: 13px">
                  Selecciona las listas de precios que puede usar este afiliado.
                  Solo se muestran las de su misma ciudad. Marca una como predeterminada.
                </p>

                <p v-if="!availablePriceTypes.length" class="text-muted">
                  No hay listas de precios activas en la ciudad de este afiliado.
                </p>

                <table v-else class="custom-table w-100">
                  <thead>
                    <tr>
                      <th style="width: 60px" class="text-center">Vincular</th>
                      <th>Lista</th>
                      <th>Código</th>
                      <th style="width: 120px" class="text-center">Predeterminada</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="pt in availablePriceTypes" :key="pt.id">
                      <td class="text-center">
                        <input type="checkbox" :checked="isLinked(pt.id)" @change="toggleLink(pt.id)" />
                      </td>
                      <td>{{ pt.name }}</td>
                      <td><code>{{ pt.code }}</code></td>
                      <td class="text-center">
                        <input type="radio" name="apt-default" :disabled="!isLinked(pt.id)"
                          :checked="defaultPriceTypeId === pt.id" @change="setDefault(pt.id)" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Precios por categoría (NT-FS-006 §8) -->
              <div v-if="editing && linkedPriceTypes.length" class="mt-4">
                <h2 class="form-subtitle">Precios por categoría</h2>
                <p class="text-muted" style="font-size: 13px">
                  Carga los precios fijos por vehículo y dirección para cada lista vinculada.
                  Una celda vacía significa que esa combinación no tiene precio.
                </p>

                <div v-for="lista in linkedPriceTypes" :key="'precios-' + lista.id" class="mb-4">
                  <h4 style="font-size: 15px; font-weight: 600; margin-bottom: 8px">
                    Precios: {{ lista.name }}
                  </h4>
                  <table class="custom-table w-100">
                    <thead>
                      <tr>
                        <th>Dirección</th>
                        <th class="text-center" v-for="veh in vehicleColumns" :key="'h-' + veh">{{ veh }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Aeropuerto → Hotel</td>
                        <td v-for="veh in vehicleColumns" :key="'a2h-' + lista.id + '-' + veh">
                          <input type="number" min="0" step="0.01" class="custom-form-control"
                            v-model="precios[lista.id].airport_to_affiliate[veh]" />
                        </td>
                      </tr>
                      <tr>
                        <td>Hotel → Aeropuerto</td>
                        <td v-for="veh in vehicleColumns" :key="'h2a-' + lista.id + '-' + veh">
                          <input type="number" min="0" step="0.01" class="custom-form-control"
                            v-model="precios[lista.id].affiliate_to_airport[veh]" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <div class="form-group-buttons text-right">
                    <router-link :to="{ name: 'config-affiliate-list' }" class="button button-light">
                      {{ editing ? "Volver" : "Cancelar" }}
                    </router-link>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormSelect, FormError, FormInput } from "wize-admin";

import { AffiliateService, CategoryService, PriceTypeService } from "@/core/services";
import { Constants as LocalConstants } from "@/core/utils";
import { required, requiredIf, numeric, helpers, email } from "vuelidate/lib/validators";

export default {
  components: {
    FormError,
    FormSelect,
    FormInput
  },
  data() {
    return {
      identifierTypes: [
        LocalConstants.IdentifierType.DNI,
        LocalConstants.IdentifierType.RUC,
        LocalConstants.IdentifierType.CE,
        LocalConstants.IdentifierType.PASSPORT,
      ],
      commissionOptions: [
        LocalConstants.CommissionOptions.PERCENTAGE,
        LocalConstants.CommissionOptions.FIXED_AMOUNT
      ],
      hotelTypesOptions: [
        LocalConstants.HotelTypes.BOUTIQUE,
        LocalConstants.HotelTypes.STANDARD,
        LocalConstants.HotelTypes.RESORT
      ],
      form: {
        identifier_type: null,
        identifier_number: null,
        name: null,
        address: null,
        contact_person: null,
        phone_number: null,
        commission: null,
        commission_type: null,
        category_id: null,
        hotel_type: null,
        email: null
      },
      categories: [],
      editing: false,
      // Listas de precios vinculadas (DEF-ADM-010)
      availablePriceTypes: [],   // listas activas de la ciudad del afiliado
      linkedIds: [],             // price_type_ids seleccionados
      defaultPriceTypeId: null,  // cuál es la predeterminada
      // Precios por categoría (NT-FS-006 §8)
      vehicleColumns: ["Sedan", "SUV", "VAN", "Sprinter"], // casing exacto de la BD
      precios: {},               // { [priceTypeId]: { airport_to_affiliate:{...}, affiliate_to_airport:{...} } }
    };
  },
  validations: {
    form: {
      identifier_type: { required },
      identifier_number: { required },
      name: { required },
      phone_number: { required, startsWithPlus: helpers.regex('startsWithPlus', /^\+/) },
      commission: { required, numeric },
      commission_type: { required },
      category_id: { required },
      hotel_type: {
        required: requiredIf(function () {
          return this.form.category_id === LocalConstants.AffiliateCategories.HOTEL.key
        })
      },
      email: { email, required }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  computed: {
    maxLengthIdentifier: function () {
      if (this.form.identifier_type) {
        const type = this.identifierTypes.find(
          (i) => i.key === this.form.identifier_type
        );
        return type.length;
      }
      return 11;
    },
    isHotel: function () {
      return this.form.category_id === LocalConstants.AffiliateCategories.HOTEL.key;
    },
    // Listas actualmente vinculadas (NT-FS-006 §8): las que tienen tabla de precios.
    linkedPriceTypes: function () {
      return this.availablePriceTypes.filter((pt) => this.linkedIds.includes(pt.id));
    }
  },
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          ...this.form,
          commission: Number(this.form.commission),
          commission_type: parseInt(this.form.commission_type)
        };

        if (!this.editing) {
          await AffiliateService.save(data);

          this.$router.push({
            name: "config-affiliate-list",
          })
        } else {
          await AffiliateService.update(this.$route.params.id, data);
          await this.savePriceTypes(this.$route.params.id);
          await this.saveAffiliatePrices(this.$route.params.id);
          this.load(this.$route.params.id);
        }

        Alert.success("Se almacenó la información correctamente");
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await AffiliateService.get(id);
        const payload = response.payload;

        this.form = {
          ...payload,
        };

        this.editing = true;
        await this.loadPriceTypesData(id);
        await this.loadAffiliatePrices(id);
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "form-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    // ── Listas de precios del afiliado (DEF-ADM-010) ──────────────
    isLinked(priceTypeId) {
      return this.linkedIds.includes(priceTypeId);
    },
    toggleLink(priceTypeId) {
      if (this.isLinked(priceTypeId)) {
        this.linkedIds = this.linkedIds.filter((id) => id !== priceTypeId);
        // si se desvincula la predeterminada, se limpia
        if (this.defaultPriceTypeId === priceTypeId) this.defaultPriceTypeId = null;
      } else {
        this.linkedIds.push(priceTypeId);
        // primera vinculada pasa a predeterminada por comodidad
        if (this.defaultPriceTypeId === null) this.defaultPriceTypeId = priceTypeId;
        // asegurar estructura de precios para la nueva lista (NT-FS-006 §8)
        if (!this.precios[priceTypeId]) {
          this.$set(this.precios, priceTypeId, this.emptyPriceStruct());
        }
      }
    },
    setDefault(priceTypeId) {
      if (this.isLinked(priceTypeId)) this.defaultPriceTypeId = priceTypeId;
    },
    async loadPriceTypesData(id) {
      // Listas activas de la ciudad del afiliado (X-City-Id lo pone el interceptor)
      const ptRes = await PriceTypeService.list();
      this.availablePriceTypes = (ptRes.payload || []).filter((p) => p.is_active);

      // Vinculaciones existentes
      const linkRes = await AffiliateService.getPriceTypes(id);
      const links = linkRes.payload || [];
      this.linkedIds = links.map((l) => l.price_type_id);
      const def = links.find((l) => l.is_default);
      this.defaultPriceTypeId = def ? def.price_type_id : null;
    },
    async savePriceTypes(id) {
      // Solo se envía si hay UI de listas (modo edición con listas disponibles)
      if (!this.availablePriceTypes.length) return;
      const items = this.linkedIds.map((priceTypeId) => ({
        price_type_id: priceTypeId,
        is_default: priceTypeId === this.defaultPriceTypeId,
      }));
      await AffiliateService.setPriceTypes(id, items);
    },
    // ── Precios por categoría (NT-FS-006 §8) ──────────────────────
    emptyPriceStruct() {
      return {
        airport_to_affiliate: { Sedan: "", SUV: "", VAN: "", Sprinter: "" },
        affiliate_to_airport: { Sedan: "", SUV: "", VAN: "", Sprinter: "" },
      };
    },
    async loadAffiliatePrices(id) {
      // Construir la estructura vacía de todas las listas vinculadas de forma
      // síncrona para que los v-model tengan destino antes de rellenar montos.
      const base = {};
      this.linkedPriceTypes.forEach((pt) => {
        base[pt.id] = this.emptyPriceStruct();
      });
      this.precios = base;

      for (const pt of this.linkedPriceTypes) {
        try {
          const res = await AffiliateService.getPrices(id, pt.id);
          (res.payload || []).forEach((p) => {
            if (this.precios[pt.id][p.route_type]) {
              this.precios[pt.id][p.route_type][p.vehicle_type] = p.amount;
            }
          });
        } catch (e) {
          // La lista aún no tiene precios cargados: se deja vacía.
        }
      }
    },
    async saveAffiliatePrices(id) {
      // PUT por cada lista vinculada. Celdas vacías no se envían (reemplazo total).
      for (const pt of this.linkedPriceTypes) {
        const struct = this.precios[pt.id];
        if (!struct) continue;
        const prices = [];
        ["airport_to_affiliate", "affiliate_to_airport"].forEach((route) => {
          this.vehicleColumns.forEach((veh) => {
            const raw = struct[route][veh];
            if (raw !== "" && raw !== null && raw !== undefined) {
              const amount = parseFloat(raw);
              if (!isNaN(amount)) {
                prices.push({ vehicle_type: veh, route_type: route, amount });
              }
            }
          });
        });
        await AffiliateService.setPrices(id, pt.id, prices);
      }
    },
    async getCategories() {
      try {
        await this.$store.dispatch("app/loading", true);

        const response = await CategoryService.listAll();
        this.categories = JSON.parse(JSON.stringify(response.payload));

        this.categories = this.categories.map(cat => ({
          key: cat.id,
          label: cat.name
        }));

      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    }
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);

    await this.getCategories();
  },
};
</script>

<style lang="stylus" scoped></style>
